import { jsonMember, jsonObject } from 'typedjson';
import { ShippingMethodCode } from '../../../shared/enums/shipping-method-code';
import { Guid } from '@web/utils';

@jsonObject
export class PublicOrderShipmentMethodResponse {
  @jsonMember(String)
  public readonly id!: Guid;

  @jsonMember(String)
  public readonly name!: string;

  @jsonMember(String)
  public readonly code!: ShippingMethodCode;
}
